<ng-container *ngIf="desktop | async">
  <div class="section_8">
    <div class="wrapper">
      <div class="section_8-cta">
        <div class="section_8-img qr">
          <div class="qr-code-wrapper">
            <qrcode [margin]="0" [qrdata]="link" [colorDark]="'#fff'" [colorLight]="'#2E2E51'" [width]="221" [errorCorrectionLevel]="'M'"></qrcode>
          </div>
          <!-- <img src="/assets/images/Frame 1467.png" alt="download the app"> -->
          <div class="cta">
            <div class="cta-header">
              <ng-container i18n>Download the app!</ng-container>
            </div>
            <div class="cta-content">
              <ng-container i18n>Hostel Hop charges a lower booking fee to hostels, helping travelers to save even.</ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="section_8-img notes">
        <img [ngSrc]="'../assets/images/image 55.webp'" [width]="598" [height]="439" alt="">
      </div>
      <div class="section_8-img lady">
        <img [ngSrc]="'../assets/images/girl.webp'" [width]="495" [height]="695" alt="">
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!(desktop | async)">
  <div class="section_8-sm">
    <div class="title">
      <ng-container i18n>Download the app!</ng-container>
    </div>
    <div class="subtitle">
      <ng-container i18n>Hostel Hop charges a lower booking fee to hostels, helping travelers to save even.</ng-container>
    </div>
    <div class="button-wrapper">
      <a class="btn btn-large" [routerLink]="['/download']">
        <span>
          <ng-container i18n>Download on the App Store</ng-container>
        </span>
      </a>
    </div>
    <div class="notes-wrapper">
      <div class="section_8-img notes">
        <img ngOptimizedImage [ngSrc]="'../assets/images/image 55.webp'" [width]="390" [height]="287" alt="">
      </div>
    </div>
    <div class="section_8-img lady">
      <img ngOptimizedImage [ngSrc]="'../assets/images/girl.webp'" [width]="314" [height]="440" alt="">
    </div>
  </div>
</ng-container>
